import React from 'react';
import Header from '../common/header';
import About1 from '../layout/about/about1';
import Footer from '../common/footer';
import About from '../common/about1';
import About2 from '../layout/about/about2';
import About3 from '../layout/about/about3';
import About4 from '../layout/about/about4';
import Ourclient from '../common/ourclient';
import Ourvision1 from '../layout/vision/ourvision1';
import Ourmission1 from '../layout/mission/ourmission';
import Corevalues from '../layout/core value/corevalues';
import Aboutpage2 from '../common/aboutpage2';


function Aboutmain() {
    return (
        <div>
            <Header />
            <br />
            <About2 />
            <br />
        <Aboutpage2></Aboutpage2>
            <br />

            <About3 />
            <br />
            <About4 />
            <br />
            <Ourvision1 />
            <br />
            <Ourmission1 />
            <br />
            <Corevalues />
            <br />
            <Ourclient />
            <br />
            <Footer />

        </div>


    )
}

export default Aboutmain;
